import axios from 'axios';

export const laboralRoutes = props => {
  return {
    defaultRequestParams: {},
    createRoute: Routes.bulk_datatable_distribution_list_filter_laborals_path,
    indexRoute: Routes.bulk_datatable_distribution_list_filter_laborals_path,
    destroyRoute: Routes.bulk_datatable_distribution_list_filter_laboral_path,
    updateRoute: Routes.bulk_datatable_distribution_list_filter_laboral_path,
  }
}

export const routes = {
  laboral: laboralRoutes
}


export const createService = async (url, data) => {
  const response = await axios({
    method: 'post',
    url: url,
    data: data,
    headers: {
      'X-CSRF-TOKEN': window.compliance.token
    }
  })

  return response;
}

export const updateService = async (url, data) => {
  const response = await axios({
    method: 'put',
    url: url,
    data: data,
    headers: {
      'X-CSRF-TOKEN': window.compliance.token
    }
  })

  return response;
}

export const indexService = async(url) => {
  const response = await axios({
    method: 'get',
    url: url,
    headers: {
      'X-CSRF-TOKEN': window.compliance.token
    }
  })

  return response;
}

export const destroyService = async(url) => {
  const response = await axios({
    method: 'delete',
    url: url,
    headers: {
      'X-CSRF-TOKEN': window.compliance.token
    }
  })

  return response;
}
